module.exports = __webpack_public_path__ + "img/bg_bv.fc802042.jpg";